import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Globals} from '../../../globals';
import {JarwisService} from '../../../services/jarwis.service';
import {TokenService} from '../../../services/token.service';
import {AuthService} from '../../../services/auth.service';
import {AuthHttpService} from "../../../services/auth-http.service";
import {MatDialog} from '@angular/material/dialog';
import {forkJoin} from 'rxjs';
import {UserService} from '../../../services/user.service';

class Signup {
  constructor(public email: string = '') {
  }
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  model: Signup = new Signup();

  public form = {
    email: null,
    password: null
  }
  public error = null;

  constructor(
    private Jarwis: JarwisService,
    private Auth: AuthService,
    private Token: TokenService,
    private router: Router,
    public translate: TranslateService,
    public Globals: Globals,
    private http: AuthHttpService,
    public dialog: MatDialog,
    private UserService: UserService
  ) {
    this.Globals.lang_select = this.Globals.lang;
    this.changeLangCancel = this.Globals.langJS.subscribe(() => {
      this.onLangChanged();
      this.translate.use(this.Globals.lang)
    });  }

  password: string;
  email: string;
  showResetForm: boolean = false;
  showLoginForm: boolean = true;
  showValueForm: boolean = false;
  public showErrors = false;
  user_data: any;
  error_data: string;
  changeLangCancel: any;
  show_new_pass = false;
  userpass_1: string;
  userpass_2: string;
  pass_check = false;
  empty_fields = true;
  check_class = '';
  id = '';
  user_sub: any;
  login_done: boolean = true;

  onLangChanged() {
    forkJoin([
      this.translate.get('error_data')
    ]).subscribe((res) => {
      this.error_data = res[0];
    });
  }

  onSubmit() {
    //console.log(this.form);
    this.Globals.user = null;
    this.Globals.select_project = null;
    this.login_done = false;
    this.Jarwis.login(this.form).subscribe(
      data => this.handleResponse(data),
      error => this.handleError(error)
    );
    this.Globals.sign_in = true;
  }

  handleResponse(data) {
    this.Token.handle(data.access_token);
    this.Auth.changeAuthStatus(true);
    this.getUser();
    //this.router.navigateByUrl('/main');
  }

  handleError(error: any) {
    this.showErrors = error;
    this.login_done = true;
  }

  ToggleReset() {
    this.showResetForm = !this.showResetForm;
    this.showLoginForm = !this.showLoginForm;
  }

  ToggleValue() {
    this.showValueForm = !this.showValueForm;
    this.showResetForm = !this.showResetForm;
    this.showErrors = false;
  }

  onKey() { // without type info
    this.showErrors = null;
  }

  changeLang_new() {
    this.Globals.lang = this.Globals.lang_select;
    this.translate.use(this.Globals.lang);
    this.Globals.langJS.next(this.Globals.lang);
  }

  getUser() {

    //проверяем заполнен ли глобальный юзер, если нет, загружаем
    let recieved_user: any = this.UserService.getUserGlobalData();
    if (Boolean(recieved_user) && Object.keys(recieved_user).length) {
      this.user_data = JSON.parse(JSON.stringify(this.UserService.getUserGlobalData()));
      this.afterGet();
    } else {
      this.user_sub = this.UserService.user().subscribe((user) => {
        this.user_data = JSON.parse(JSON.stringify(user));
        //console.log('this.user_data',this.user_data);
        if (Boolean(this.user_data)) {
          this.showErrors = false;
          this.afterGet();
        } else {
          this.showErrors = true;
          this.router.navigateByUrl('/auth/logout');
        }
      });
    }
  }

  afterGet() {
    this.id = this.user_data.users_id;
    if (!this.user_data.pass_change_on_login) {
      this.show_new_pass = false;
      this.login_done = true;
      this.router.navigateByUrl('/main');
    } else {
      this.show_new_pass = true;
      this.login_done = true;
    }
  }

  //функция для проверки ввода паролей
  passCheck() {
    if (Boolean(this.userpass_1) && Boolean(this.userpass_2)) {
      this.empty_fields = false;
      if (this.userpass_1 != this.userpass_2) {
        this.pass_check = false;
        this.check_class = 'need_valid ng-invalid';
      } else {
        this.pass_check = true;
        this.check_class = 'need_valid ng-valid';
      }
    } else {
      this.empty_fields = true;
      this.check_class = '';
    }
  }

  savePass() {
    this.Globals.data_has_changed = true;
    let params: any = {};

    if (this.id != '' && this.id != null) {
      params['id'] = this.id;
    }

    params['changepass'] = 'false';
    if (this.userpass_1 != '' && this.userpass_1 != null && this.userpass_1 === this.userpass_2) {
      params['password'] = this.userpass_1;
    }

    this.http.post('/api/users/user_data/update', params).subscribe(() => {
      params
    });
    this.router.navigateByUrl('/main');
  }

  ngOnDestroy() {
    if (Boolean(this.changeLangCancel))
      this.changeLangCancel.unsubscribe();
    if (Boolean(this.user_sub))
      this.user_sub.unsubscribe();
  }
}
